const appendOnboardingIntroChatMessage = (payload) => ({ type: 'onboardingAppendIntroChatMessage', payload });

export default appendOnboardingIntroChatMessage;
